import React from 'react'
import { PageContent, ModalLayer, IconButton } from '@ui'
import Appbar from 'components/Appbar'
import { useReload } from '@hooks/reloadContext'
import { Router, RouteComponentProps } from '@reach/router'
import { navigateWithBasepath } from '../../App'
import TableView from './TableView'
import useBuildingTypes from './hooks/useBuildingTypes'
import BuildingTypeSearch from './BuildingTypeSearch'
import { legacyMode } from 'App'
import { navigateToAphrodite } from '@utils/navigateToAphrodite'

export default function BuildingTypeManagement({ navigate }: RouteComponentProps) {
  const reload = useReload()
  const buildingTypes = useBuildingTypes()
  return (
    <>
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <Router primary={false} navigate={navigateWithBasepath}>
        <ModalLayer path="*" reload={reload.buildingTypes} />
      </Router>
      <Appbar
        title={
          legacyMode ? (
            <div className="flex items-center">
              <span className="mr-2">
                <IconButton
                  minimal
                  iconName="chevron-left"
                  onClick={() => navigateToAphrodite('/settings')}
                />
              </span>
              Building Types
            </div>
          ) : (
            'Building Types'
          )
        }
      >
        <BuildingTypeSearch hook={buildingTypes} navigate={navigate} />
      </Appbar>

      <PageContent>
        <TableView buildingTypes={buildingTypes} navigate={navigate} />
      </PageContent>
    </>
  )
}
